import { render } from "./Baseinfo.vue?vue&type=template&id=6b2e8342&scoped=true"
import script from "./Baseinfo.vue?vue&type=script&lang=js"
export * from "./Baseinfo.vue?vue&type=script&lang=js"

import "./Baseinfo.vue?vue&type=style&index=0&id=6b2e8342&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2e8342"]])

export default __exports__